import { useState, useRef, useEffect, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import SelectBox from '../../../shared/controls/form/selectBox';
import { DateBox, TextArea, TextBox } from '../../../shared/controls/form';
import HeaderProfileBlock from '../../sharedChild/headerImage/headerProfileBlock';
import { useDispatch, useSelector } from 'react-redux';
import Attachments from '../../sharedChild/attachment/attachments';
import Email from '../../sharedChild/email/emails';
import Timeline from '../../sharedChild/timeline';
import Notes from '../../sharedChild/note/notes';
import {
  getGenericMasterFilteredListByKey,
  getInvoice,
  getInvoiceById,
  getOpportunityById,
  getUserRole,
} from '../../../redux/selector';
import {
  fetchAttachmentsAndAppendToModule,
  fetchDetailAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchInvoiceSalesOrderedItemAndAppendToModule,
  fetchNotesAndAppendToModule,
  singleRowAddUpdateInStore,
} from '../../../redux/actions';
import SalesOrder from '../salesOrder';
import InvoiceForm from './invoiceForm';
import { Button, Modal } from 'react-bootstrap';
import apiServices from '../../../services/service';
import { toast } from 'react-toastify';
import { isLoadingByKey } from '../../../shared/controls/methods/getLoadingState';
import Loader from '../../../shared/component/Loader';
import EmailPopUp from '../../sharedChild/emailPopUp';

export const ViewInvoice = () => {
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'invoice');
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(storeLoading);
  const [showModal, setShowModal] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();
  const invoiceList = useSelector(getInvoice);
  const [refreshView, setRefreshView] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const userRole = useSelector(getUserRole);
  const role = userRole || '';
  const isSystemManager = role === 'System Manager';

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -250px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  });

  const [formData, setFormData] = useState({
    type: 'view',
    paymentMethod: '',
    paymentDate: '',
    referenceNumber: '',
  });

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: convertedValue,
    }));
  };

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }

  const [quoteDataInvoice] = useState([
    {
      id: 1,
      subject: 'Website Design Services',
      status: 'Paid',
      invoiceDate: '2024-03-01',
      grandTotal: '$1,200.00',
      contactName: 'John Doe',
      accountName: 'Acme Corp',
      invoiceOwner: 'Rajesh Kumar',
    },
    {
      id: 2,
      subject: 'Logo Design Package',
      status: 'Unpaid',
      invoiceDate: '2024-03-05',
      grandTotal: '$950.00',
      contactName: 'Jane Smith',
      accountName: 'Beta Inc.',
      invoiceOwner: 'Anita Mehra',
    },
    {
      id: 3,
      subject: 'Business Card Printing',
      status: 'Overdue',
      invoiceDate: '2024-02-20',
      grandTotal: '$300.00',
      contactName: 'Sam Roy',
      accountName: 'Gamma Ltd.',
      invoiceOwner: 'Vikram Saini',
    },
  ]);

  const quoteColumnDefsInvoice = [
    {
      headerName: 'Action',
      field: 'view',
      pinned: 'left',
      width: 80,
      resizable: false,
      sortable: false,
      filter: false,
      cellRenderer: (params) => (
        <img
          src="../../assets/images/eye.png"
          alt="View"
          title="View"
          style={{ cursor: 'pointer', width: '11px' }}
          onClick={() => handleViewRow(params.data)}
        />
      ),
    },
    { headerName: 'Subject', field: 'subject', sortable: true, filter: true },
    { headerName: 'Status', field: 'status', sortable: true, filter: true },
    {
      headerName: 'Invoice Date',
      field: 'invoiceDate',
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Grand Total',
      field: 'grandTotal',
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Contact Name',
      field: 'contactName',
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Account Name',
      field: 'accountName',
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Invoice Owner',
      field: 'invoiceOwner',
      sortable: true,
      filter: true,
    },
  ];

  const defaultColDefInvoice = useMemo(
    () => ({
      sortable: true,
      editable: false,
      flex: 1,
      minWidth: 120,
      filter: true,
      resizable: true,
      enableValue: true,
      enableRowGroup: false,
      enablePivot: true,
    }),
    []
  );

  const [quoteData] = useState([
    {
      sNo: 1,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 2,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 3,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 4,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
    {
      sNo: 5,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
    {
      sNo: 6,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
    {
      sNo: 7,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
    {
      sNo: 8,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
    {
      sNo: 9,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 10,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 11,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },

    {
      sNo: 12,
      productName: 'Lorem Ipsum Dolor',
      quantity: 1,
      listPrice: '100.00',
      amount: '100.00',
      discount: '10.00',
      tax: '10.00',
      total: '100.00',
    },
  ]);

  const quoteColumnDefs = [
    {
      headerName: 'S.No.',
      field: 'sNo',
      sortable: false,
      filter: false,
      maxWidth: 70,
      resizable: false,
      editable: false,
    },
    {
      headerName: 'Product Name',
      field: 'productName',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Quantity',
      field: 'quantity',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Amount ($)',
      field: 'amount',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Discount ($)',
      field: 'discount',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Tax ($)',
      field: 'tax',
      sortable: true,
      filter: true,
      editable: true,
      width: 150,
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Total ($)',
      field: 'total',
      sortable: true,
      filter: true,
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
  ];
  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 20,
    filter: true,
    resizable: true,
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    enableRowGroup: false,
    // allow every column to be pivoted
    enablePivot: true,
    //cellRenderer: supressEdit,
  }));

  const handleEditInvoice = () => {
    navigate(`/sales/editInvoice?id=${formData?.id}`, {
      state: {
        ...invoiceLocalData,
        from: 'view',
      },
    });
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    // setErrorMsg((prevErrorMsg) => ({
    //   ...prevErrorMsg,
    //   [name]: undefined,
    // }));
    if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });

      // setFormEdited(true);
    }
  };

  const invoiceStatus = useSelector(getGenericMasterFilteredListByKey('InvoiceStatus'));

  const sendEmail = async () => {
    try {
      const cleanedData = {
        ...invoiceLocalData,
        invoiceDetails:
          invoiceLocalData.invoiceDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };

      if (cleanedData.dueDate == null) {
        delete cleanedData.dueDate;
      }

      if (cleanedData.invoiceDate == null) {
        delete cleanedData.invoiceDate;
      }

      if (cleanedData.paymentDate == null) {
        delete cleanedData.paymentDate;
      }

      const response = await apiServices.sendEmailForInvoicePdf(cleanedData);

      if (response.status === 200 && response.data?.toLowerCase() === 'email sent successfully') {
        toast.success(response.data); // Show success toast
      } else {
        toast.error('Failed to send email.'); // Optional: show error toast
        console.error('Failed to send email:', response);
      }
    } catch (error) {
      toast.error('An error occurred while sending email.');
      console.error('Error sending quote email:', error);
    }
  };

  const downloadPdf = async () => {
    setLoading(true)
    try {
      // Prepare data to send (clean up if necessary)
      const cleanedData = {
        ...invoiceLocalData,
        invoiceDetails:
          invoiceLocalData.invoiceDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };
      delete cleanedData.notesList;
      delete cleanedData.createdDateTime;
      delete cleanedData.updatedDateTime;

      // Make API call with responseType: 'blob'
      const response = await apiServices.getInvoicePdf(cleanedData);

      if (response.status === 200 && response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${invoiceLocalData?.code}.pdf`; // ✅ dynamic name with .pdf
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoading(false)
      } else {
        console.error('Failed to download PDF', response);
        toast.error('Failed to download PDF', { position: 'top-right' });
        setLoading(false)
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      toast.error('An unexpected error occurred while downloading PDF.', { position: 'top-right' });
      setLoading(false)
    }
  };

  const handleSubmit = (formData) => {
    setLoading(true);
    apiServices
      .updateInvoice(formData)
      .then((response) => {
        if (response.status === 200) {
          const id = response.data;
          setShowModal(false);

          dispatch(
            singleRowAddUpdateInStore({
              moduleName: 'Invoice',
              id: formData?.type === 'add' ? id : formData.id,
              rowIndex: formData.rowIndex,
            })
          );
          setLoading(false);
          toast.success('Marked as Paid', {
            position: 'top-right',
          });
          setRefreshView((prev) => !prev);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleViewRow = (row) => {
    navigate(`/sales/viewInvoice?id=${row.id}`);
  };
  const [invoiceLocalData, setInvoiceLocalData] = useState({
    ...(location.state || {}),
    type: 'view',
    from: 'view',
  });

  const invoiceStoreData = useSelector((state) => {
    const invoiceId = location.state?.id || id;
    return getInvoiceById(state, invoiceId);
  });

  console.log('invoiceStoreData===========================>>>>>>>>>>>>>>>>>>>', invoiceStoreData);

  useEffect(() => {
    setInvoiceLocalData((prev) => ({ ...prev, ...invoiceStoreData }));
    // if (invoiceStoreData?.details) {
    //   setInvoiceLocalData(invoiceStoreData?.details);
    // }
  }, [invoiceStoreData]);

  useEffect(() => {
    const invoiceId = location.state?.id || id;
    if (location.pathname.includes('viewInvoice')) {
      setFormData({
        ...invoiceLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (invoiceId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Invoice',
          id: invoiceId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Invoice',
          id: invoiceId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Invoice',
          id: invoiceId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Invoice',
          id: invoiceId,
        })
      );
      dispatch(
        fetchInvoiceSalesOrderedItemAndAppendToModule({
          moduleName: 'Invoice',
          id: invoiceId,
        })
      );
    }
  }, [location, invoiceLocalData?.id, refreshView]);

  const isDisabled =
    invoiceLocalData?.status &&
    ['paid', 'void', 'cancelled'].includes(invoiceLocalData.status.toLowerCase()) &&
    !isSystemManager;

  const isLocked =
    invoiceLocalData?.status &&
    ['paid', 'void', 'cancelled'].includes(invoiceLocalData.status.toLowerCase());

  return (
    <>
      {loading && <Loader />}
      <div id="viewsales">
        <div className="viewPageOuter">
          <div className="viewHeader">
            <HeaderProfileBlock localData={invoiceLocalData} moduleName={'Invoice'} View={true} />
            <div className="rightAction">
              {isLocked && (
                <i
                  class="bi bi-lock-fill"
                  title="This invoice is locked and cannot be edited due to its current status"
                  style={{ color: '#3a5afe' }}
                ></i>
              )}
              <button
                className={`btn btn-outline-primary ${isDisabled ? 'disabled' : ''}`}
                onClick={handleEditInvoice}
                disabled={isDisabled}
              >
                Edit
              </button>
              {/* <button className="btn btn-primary" onClick={sendEmail}>
                Send Email
              </button> */}
              <div id="sendmail">
                <EmailPopUp localData={invoiceLocalData} module={'Invoice'} />
              </div>
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={downloadPdf}
                disabled={loading} // disable when loading
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Downloading...
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      className="bi bi-download"
                      viewBox="0 0 16 16"
                      style={{ marginRight: '6px' }}
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.6v3.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.5a.5.5 0 0 1 1 0v3.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10.5a.5.5 0 0 1 .5-.6zm7.5-9a.5.5 0 0 1 .5.5v8.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V1.5a.5.5 0 0 1 .5-.5z" />
                    </svg>
                    Download PDF
                  </>
                )}
              </button>
              <button
                type="button"
                className={`btn ${invoiceLocalData?.status === 'Paid' ? 'btn-success' : 'btn-primary'} d-flex align-items-center gap-2`}
                onClick={handleOpenModal}
                disabled={invoiceLocalData?.status === 'Paid'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z" />
                  <path d="M10.97 5.97a.75.75 0 0 1 1.07 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L5.324 9.384a.75.75 0 1 1 1.06-1.06l1.094 1.093 3.492-4.446z" />
                </svg>
                {invoiceLocalData?.status === 'Paid' ? 'Paid' : 'Mark As Paid'}
              </button>
            </div>
          </div>
          <div className="detailContainer">
            <div className="viewFormContainer">
              <div className="leftBlock">
                <ul>
                  {Object.keys(refs).map((key) => (
                    <li
                      key={key}
                      onClick={() => scrollToSection(key)}
                      style={{ cursor: 'pointer' }}
                      className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                    >
                      <button onClick={() => setActiveTab(key)}>{toTitleCaseFromCamel(key)}</button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rightBlock" id="detailPageRight">
                <div className="addlead_container">
                  <Formik>
                    <Form id="viewForm">
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12">
                          <div className="addleadcard1">
                            <div className={'view' ? 'addleadcard-view' : 'addleadcard m-0 p-0'}>
                              <div id="overview" className="scrollTo" ref={refs.overview}></div>
                              <div className="row gx-3">
                                <InvoiceForm formData={invoiceLocalData} />
                                <div className="tab-content">
                                  <div>
                                    <div>
                                      <div>
                                        <div></div>
                                      </div>
                                    </div>

                                    <div
                                      id="attachments"
                                      className="scrollTo"
                                      ref={refs.attachments}
                                    ></div>
                                    <Attachments localData={invoiceLocalData} module={'Invoice'} />
                                    <div id="emails" className="scrollTo" ref={refs.emails}></div>
                                    <Email localData={invoiceLocalData} module={'Invoice'} />
                                  </div>
                                  <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                                  <Timeline localData={invoiceLocalData} module={'Invoice'} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
            <div className="viewFormNotesOuter">
              <div className="ViewFormNotesContainer">
                <Notes leadLocalData={invoiceLocalData} module={'Invoice'} />
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Mark Invoice as Paid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik>
              <Form>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="input-container">
                      <TextBox
                        isRequired={false}
                        label={'Payment Method'}
                        name={'paymentMethod'}
                        placeholder={
                          // formData?.type === "view"
                          //   ? formData?.paymentMethod || "--"
                          //   : formData?.paymentMethod ||
                          'Enter Payment Method'
                        }
                        handleChange={handleChangeForm}
                        value={formData?.paymentMethod}
                        // disabled={formData?.type === "view"}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="input-container">
                      <div className="dateBox">
                        <label>Date of Payment</label>
                        {/* {formData?.type === "view" &&
                              !formData?.paymentDate ? (
                                <div>--</div>
                              ) : ( */}
                        <div className="dtBox custom-date-wrapper">
                          <DateBox
                            name={'paymentDate'}
                            className="custom-date-input"
                            placeholder={
                              // formData?.type === "view"
                              //   ? "--"
                              'Enter Due Date (MM/DD/YYYY)'
                            }
                            value={
                              formData?.paymentDate ? formData?.paymentDate.substring(0, 10) : ''
                            }
                            // disabled={formData?.type === "view"}
                            handleChange={handleChangeForm}
                          />
                        </div>
                        {/* )} */}
                      </div>
                    </div>
                  </div>

                  {/* ── Reference Number ──────────────────── */}
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="input-container">
                      <TextBox
                        isRequired={false}
                        label={'Reference Number'}
                        name={'referenceNumber'}
                        placeholder={
                          // formData?.type === "view"
                          //   ? formData?.referenceNumber || "--"
                          //   : formData?.referenceNumber ||
                          'Enter Reference Number'
                        }
                        handleChange={handleChangeForm}
                        value={formData?.referenceNumber}
                        // disabled={formData?.type === "view"}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="input-container">
                      <SelectBox
                        label="Status"
                        name={'statusId'}
                        placeholder={
                          formData?.type === 'view'
                            ? formData?.status || '--'
                            : formData?.status || 'Select Status'
                        }
                        isRequired={false}
                        // disabled={formData?.type === "view"}
                        selectedOptions={selectedOptions?.status}
                        handleSelect={handleChange}
                        options={invoiceStatus}
                        optionKeys={['id', 'displayName']}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            </Formik>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={() => handleSubmit(formData)}
              // disabled={
              //   !formData.paymentMethod || !formData.paymentDate || !formData.referenceNumber
              // }
            >
              Submit Payment
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default ViewInvoice;
